// GetAll Drugs

const PLANTHERAPEUTIC_GETALL_REQUEST = 'PLANTHERAPEUTIC_GETALL_REQUEST';
const PLANTHERAPEUTIC_GETALL_SUCCESS = 'PLANTHERAPEUTIC_GETALL_SUCCESS';
const PLANTHERAPEUTIC_GETALL_FAILURE = 'PLANTHERAPEUTIC_GETALL_FAILURE';

//Create therapeuticplan
const PLANTHERAPEUTIC_CREATE_REQUEST = 'PLANTHERAPEUTIC_CREATE_REQUEST';
const PLANTHERAPEUTIC_CREATE_SUCCESS = 'PLANTHERAPEUTIC_CREATE_SUCCESS';
const PLANTHERAPEUTIC_CREATE_FAILURE = 'PLANTHERAPEUTIC_CREATE_FAILURE';

//get Drugs

const GET_DRUGS_GETALL_REQUEST = 'GET_DRUGS_GETALL_REQUEST';
const GET_DRUGS_GETALL_SUCCESS = 'GET_DRUGS_GETALL_SUCCESS';
const GET_DRUGS_GETALL_FAILURE = 'GET_DRUGS_GETALL_FAILURE';

// update therapeuticplan

const PLANTHERAPEUTIC_UPDATE_REQUEST = 'PLANTHERAPEUTIC_UPDATE_REQUEST';
const PLANTHERAPEUTIC_UPDATE_SUCCESS = 'PLANTHERAPEUTIC_UPDATE_SUCCESS';
const PLANTHERAPEUTIC_UPDATE_FAILURE = 'PLANTHERAPEUTIC_UPDATE_FAILURE';

//Delete Therapeutic plan

const PLANTHERAPEUTIC_DELETE_REQUEST = 'PLANTHERAPEUTIC_DELETE_REQUEST';
const PLANTHERAPEUTIC_DELETE_SUCCESS = 'PLANTHERAPEUTIC_DELETE_SUCCESS';
const PLANTHERAPEUTIC_DELETE_FAILURE = 'PLANTHERAPEUTIC_DELETE_FAILURE';

export {
    PLANTHERAPEUTIC_GETALL_REQUEST,
    PLANTHERAPEUTIC_GETALL_SUCCESS,
    PLANTHERAPEUTIC_GETALL_FAILURE,
    PLANTHERAPEUTIC_CREATE_REQUEST,
    PLANTHERAPEUTIC_CREATE_SUCCESS,
    PLANTHERAPEUTIC_CREATE_FAILURE,
    GET_DRUGS_GETALL_REQUEST,
    GET_DRUGS_GETALL_SUCCESS,
    GET_DRUGS_GETALL_FAILURE,
    PLANTHERAPEUTIC_UPDATE_FAILURE,
    PLANTHERAPEUTIC_UPDATE_SUCCESS,
    PLANTHERAPEUTIC_UPDATE_REQUEST,
    PLANTHERAPEUTIC_DELETE_FAILURE,
    PLANTHERAPEUTIC_DELETE_SUCCESS,
    PLANTHERAPEUTIC_DELETE_REQUEST
};